/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============== QUICK SEARCH JAVASCRIPT =============== */
/* ======================= Hazel ======================== */
/* ====================================================== */
/* ====================================================== */

var klevu_layoutType = 'slim';
var klevu_productsToShowInSlimLayout = 6;

klevu.beforeActivation('quick', function (data, scope) {
    // QUICK:
    klevu.each(klevu.search.extraSearchBox, function (key, box) {
        box.getScope().template.setTemplate(klevuQuickTemplateBaseCustom, 'klevuTemplateBase', true);
        box.getScope().template.setTemplate(klevuSearchPersonalizationsCustom, 'klevuSearchPersonalizations', true);

        box.getScope().chains.template.events.add({
            name: "hideKlevuQuickWindow",
            fire: function (data, scope) {
                // Function to handle the click event
                function handleClick() {
                    var fullPage = klevu.getSetting(box.getScope().settings, "settings.search.fullPageLayoutEnabled", true);
                    if (!fullPage) {
                        var target = klevu.getSetting(box.getScope().settings, "settings.search.searchBoxTarget");
                        target.style = "display: none !important;";
                    }
                }

                // Select all elements with class ".klevu-close-quick-search"
                const closeButtons = document.querySelectorAll('.klevu-close-quick-search');

                // Add a click event listener to each element
                closeButtons.forEach(button => {
                    button.addEventListener('click', handleClick);
                });
            }
        });
    });
});

klevu.afterTemplateRender('quick', function (data, scope) {
    function setKlevuQuickPopupTopPositionVariable() {
        klevu.each(klevu.dom.find('.klevuWrap'), function (key, currentElement) {
            const topPosition = currentElement.getBoundingClientRect().top;
            document.documentElement.style.setProperty('--klevuQuickPopupTopPosition', `${topPosition}px`);
        });
    }
    setKlevuQuickPopupTopPositionVariable();
    window.addEventListener('resize', setKlevuQuickPopupTopPositionVariable);      
});

(function (klevu) {
    klevu.extend({
        productCarousel: {
            base: {
                initProductsSlider: function (kuCarousel) {
                    return; // we don't need carousel
                }
            }
        }
    });
})(klevu);
/* ============== QUICK SEARCH TEMPLATES =============== */

var klevuQuickTemplateBaseCustom = `
<div class="klevu-fluid kuPreventDocumentClick">
    <%= helper.render('customBlockTopOuter',scope) %>
    <%  var noResClass = '';
        if (data.query.productList && data.query.productList.result.length <= 0 && data.query.contentList && data.query.contentList.result.length <= 0) {
            noResClass = 'klevuNoResultsFoundCustom';
        } 
    %>

    <div id="klevuSearchingArea" class="klevuQuickSearchingArea <%=noResClass%>">
        <div ku-container data-container-id="ku_quick_main_container" data-container-role="main">
            <%= helper.render('customBlockTop',scope) %>
            <section ku-block data-block-id="ku_quick_main_header_banner">
                <%=helper.render('klevuQuickPromotionBanner',scope,data,"top") %>                    
            </section>
            <header ku-container data-container-id="ku_quick_main_header_container" data-container-role="header">
                <section ku-block data-block-id="ku_quick_main_header_sub_panel"></section>
                <section ku-block data-block-id="ku_quick_main_header_site_navigation">
                    <div class="klevuSuggestionsBlock">                            
                        <%=helper.render('klevuQuickAutoSuggestions',scope) %>
                        <%=helper.render('klevuQuickPageSuggestions',scope) %>
                    </div>
                </section>
            </header>
            
            <% if(data.showQuickFacetedLayoutCharLimitMessage == true) { %>
                <% var quickFacetedLayoutMessage = (data.quickFacetedLayoutMinCharsTextValue) ? data.quickFacetedLayoutMinCharsTextValue : ""; %>
                <% if(quickFacetedLayoutMessage != "") { %>
                    <span class="kuFacetedLayoutMinCharText"><%= helper.translate(quickFacetedLayoutMessage) %></span>
                <% } %>                    
            <% } else { %>
                <% if(data.query.productList) { %>
                    <%=helper.render('klevuQuickTemplateResultsHeadingTitle',scope,data,"productList") %>
                    <%= helper.render('klevuQuickTemplateTabResults',scope) %>                                                 
                    <%= helper.render('klevuQuickProducts',scope) %>
                    <%= helper.render('klevuQuickOtherContent',scope) %>
                <% } else { %>              
                    <div class="kuSearchPersonalizationsContainer">
                        <%= helper.render('klevuSearchPersonalizations',scope) %>    
                    </div>
                <% } %>  
            <% } %>
        
            <footer ku-container data-container-id="ku_quick_main_footer_container" data-container-role="footer">
                <%=helper.render('klevuQuickCategorySuggestions',scope) %>
                <section ku-block data-block-id="ku_quick_main_footer_sub_panel"></section>
            </footer>
            <%= helper.render('customBlockBottom',scope) %>
            <section ku-block data-block-id="ku_quick_main_footer_banner">
                <%=helper.render('klevuQuickPromotionBanner',scope,data,"bottom") %>
            </section>
        </div>
    </div>
    <button class="klevu-close-quick-search"><svg style="pointer-events:none;" enable-background="new 0 0 386.667 386.667" height="12" viewBox="0 0 386.667 386.667" width="12"><path d="m386.667 45.564-45.564-45.564-147.77 147.769-147.769-147.769-45.564 45.564 147.769 147.769-147.769 147.77 45.564 45.564 147.769-147.769 147.769 147.769 45.564-45.564-147.768-147.77z"/></svg></button>
</div>`;

var klevuSearchPersonalizationsCustom = `
<div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content">
    <section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left" data-container-role="left">
        <div ku-block data-block-id="ku_quick_left_facets"></div>
        <div ku-block data-block-id="ku_quick_left_call_outs">
            <%=helper.render('kuTemplatePopularSearches',scope) %>
        </div>
        <div ku-block data-block-id="ku_quick_left_banner"></div>
    </section>
    <section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center" data-container-role="center">
        <header ku-block data-block-id="ku_quick_result_header"></header>
        <div ku-block data-block-id="ku_quick_result_items"></div>
                    
        <div ku-block data-block-id="ku_quick_other_items">
            <%=helper.render('klevuTrendingProducts',scope) %>
        </div>

        <footer ku-block data-block-id="ku_quick_result_footer"></footer>
    </section>
    <section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right" data-container-role="right">
        <%=helper.render('kuTemplateRecentSearches',scope) %>
        <%=helper.render('klevuRecentViewedProducts',scope) %>
        <div ku-block data-block-id="ku_quick_right_facets"></div>
        <div ku-block data-block-id="ku_quick_right_call_outs"></div>
        <div ku-block data-block-id="ku_quick_right_banner"></div>
    </section>
</div>`;

/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============ LANDING & CATNAV JAVASCRIPT ============= */
/* ===================== Essence ======================== */
/* ====================================================== */
/* ====================================================== */

// Create the useroptions object if it does not already exist
if (!window.klevu_uc_userOptions) window.klevu_uc_userOptions = {};

// set the landingFilterPosition
window.klevu_uc_userOptions.landingFilterPosition = 'left';

klevu({
  theme: {
    setHelpers: {
      all: {
        namePrettifier: function (name) {
          return name.replace(/[\[\]"]/g, "");
        },
        myCustomSortBy: function(dataLocal) {
              /* sets the selected option to the display */

              var selectedText = "";

              var klevuStorage = klevu.getSetting(klevu.settings, "settings.storage");

              switch (klevuStorage.sort.getElement(dataLocal) == dataLocal ? "RELEVANCE" : klevuStorage.sort.getElement(dataLocal)) {
                case "RELEVANCE":
                    selectedText = "Relevance";
                    break;
                case "PRICE_ASC":
                    selectedText = "Price: Low to high";
                    break;
                case "PRICE_DESC":
                    selectedText = "Price: High to low";
                    break;
                case "NAME_ASC":
                    selectedText = "Name: A to Z";
                    break;
                case "NEW_ARRIVAL_DESC":
                    selectedText = "Newest to Oldest";
                    break;
                default:
                    selectedText = "Relevance";
              }
              return selectedText;
          }
        },
    },
  },
});

klevu.beforeActivation("catnav,landing", function (data, scope) {
  scope.kScope.template.setTemplate(klevuLandingTemplateProductBlockCustom, 'productBlock', true);
  scope.kScope.template.setTemplate(landingPageProductAddToCartCustom, 'landingPageProductAddToCart', true);
  scope.kScope.template.setTemplate(KlevuLandingTemplateResultsCustom, 'results', true);
  scope.kScope.template.setTemplate(klevuLandingTemplateSearchBarCustom, 'klevuLandingTemplateSearchBar', true);
  scope.kScope.template.setTemplate(klevuLandingTemplatePaginationCustom, 'pagination', true);
  scope.kScope.template.setTemplate(klevuLandingTemplateFiltersCustom, 'filters', true);
  scope.kScope.template.setTemplate(klevuLandingTemplateSortByCustom, 'sortBy', true);
  scope.kScope.template.setTemplate(klevuLandingTemplateLimitCustom, 'Limit', true);
  scope.kScope.template.setTemplate(klevuLandingTemplateBaseCustom, 'klevuTemplateLanding', true);
  scope.kScope.template.setTemplate(klevuLandingTemplateResultsHeadingTitleCustom, 'klevuLandingTemplateResultsHeadingTitle', true);

  // Remove scrollToTop
  scope.kScope.chains.events.keyUp.remove({
    name: "scrollToTop"
  });

  (function (klevu) {
    klevu.extend(true, klevu.search.modules, {
        addParamsToURL: {
            base: {
                addURLtoHistory: function (data, scope, queryId) {
                    // Global stuff
                    if (typeof window.history === "undefined" || typeof window.history.pushState === "undefined") {
                        console.error("This browser does not have the support of window.history or window.history.pushState");
                        return;
                    }

                    var searchPath = new URLSearchParams(window.location.search);
                    var currentSearchPath;
                    var previousSearchPath = searchPath.toString();

                    // this is in case we're running our code where we dont have context.activeQueryId
                    var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
                    if (queryId && queryId.length) {
                        activeQueryId = queryId;
                    }

                    // Check if there any filter selected
                    let applyFilters = typeof data.localOverrides.query[activeQueryId].filters !== 'undefined' ? data.localOverrides.query[activeQueryId].filters.applyFilters : {};
                    let isThereFiltersSelected = false;
                    // Check if applyFilters is an object (but not an array), and not empty
                    if (typeof applyFilters === 'object' && !Array.isArray(applyFilters) && applyFilters !== null && Object.keys(applyFilters).length > 0) {
                        isThereFiltersSelected = true;
                    }

                    // PAGINATION TO URL
                    var hasPaginationEnabled = klevu.getSetting(klevu, "settings.theme.modules.pagination.searchResultsPage.enable");
                    var paginationQueryParam = "Page";
                    var currentPage = 0;

                    if (hasPaginationEnabled) {
                        var activeQueryMeta = klevu.getObjectPath(data, "template.query." + activeQueryId + ".meta");
                        if (activeQueryMeta) {
                            var productListLimit = activeQueryMeta.noOfResults;
                            currentPage = Math.ceil(activeQueryMeta.offset / productListLimit) + 1;
                        }

                        if (currentPage === 0 || currentPage === 1) {
                            searchPath.delete(paginationQueryParam);
                        } else {
                            searchPath.set(paginationQueryParam, currentPage);
                        }

                        currentSearchPath = searchPath.toString();
                    };

                    // FILTERS TO URL
                    var activeQueryFilters = klevu.getObjectPath(data, "template.query." + activeQueryId + ".filters");
                    var filterValuesQueryParam = "";

                    if (activeQueryFilters) {
                        klevu.each(activeQueryFilters, function (key, filter) {
                            var selectedFilterKeyString = "";
                            var filterOptions = filter.options;
                            var selectedValues = "";

                            if (filterOptions && filterOptions.length) {
                                klevu.each(filterOptions, function (key, option) {
                                    if (option.selected === true) {
                                        if (selectedValues.length) {
                                            selectedValues += ",";
                                        }
                                        selectedValues += option.value;
                                    }
                                });
                            } else if (filter.type === "SLIDER") {
                                var startValue = filter.start;
                                var endValue = filter.end;
                                var minValue = filter.min;
                                var maxValue = filter.max;
                                if (typeof startValue !== "undefined" && startValue !== null && typeof endValue !== "undefined" && endValue !== null) {
                                    if (Number(startValue) === Number(minValue) && Number(endValue) === Number(maxValue)) {
                                        // just skipping
                                    } else {
                                        selectedValues = startValue + "-" + endValue;
                                    }
                                }
                            }

                            if (selectedValues.length) {
                                // selectedFilterKeyString += filter.key + ":" + selectedValues;
                                selectedFilterKeyString += encodeURIComponent(filter.key) + ":" + encodeURIComponent(selectedValues);
                            }

                            if (selectedFilterKeyString.length) {
                                if (filterValuesQueryParam.length) {
                                    filterValuesQueryParam += ";";
                                }
                                filterValuesQueryParam += selectedFilterKeyString;
                            }
                        });
                    }

                    if (filterValuesQueryParam.length > 0 && isThereFiltersSelected) {
                        searchPath.set("Filters", filterValuesQueryParam);
                    } else {
                        searchPath.delete("Filters");
                    }

                    currentSearchPath = searchPath.toString();

                    // ==============================
                    // Final URL change
                    if (previousSearchPath !== currentSearchPath) {
                        var historyState = { page: currentPage, filters: currentSearchPath };
                        window.history.pushState(historyState, null, currentSearchPath ? '?' + currentSearchPath : window.location.pathname);
                    }
                },

                restoreSearchParamsOnPageLoad: function (data, scope) {
                    var hasAlreadyTriggered = klevu.getObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered");
                    if (hasAlreadyTriggered) return;

                    var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId") || "productList";

                    var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                    var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");

                    var matchedQueryParamId = "";
                    var matchedQueryParamValue = "";
                    var recordQueries = klevu.getObjectPath(data, "request.current.recordQueries");

                    if (recordQueries && recordQueries.length) {
                        klevu.each(recordQueries, function (key, recordQuery) {
                            if (recordQuery.id) {
                                if ((paginationFromURL && paginationFromURL.length) || (filtersFromURL && filtersFromURL.length)) {
                                    matchedQueryParamId = recordQuery.id;
                                    matchedQueryParamValue = paginationFromURL || filtersFromURL;
                                }
                            }
                        });
                    }

                    klevu.setObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered", true);

                    matchedQueryParamId = activeQueryId || "productList";

                    if (matchedQueryParamId.length && matchedQueryParamValue.length) {
                        activeQueryId = matchedQueryParamId;
                        var storage = klevu.getSetting(scope.kScope.settings, "settings.storage");
                        if (storage.tabs) {
                            storage.tabs.setStorage("local");
                            storage.tabs.mergeFromGlobal();
                            storage.tabs.addElement("active", activeQueryId);
                            storage.tabs.mergeToGlobal();
                        }
                    }

                    if (paginationFromURL && paginationFromURL > 1) {
                        if (recordQueries && recordQueries.length) {
                            klevu.each(recordQueries, function (key, recordQuery) {
                                if (recordQuery.id === activeQueryId) {
                                    var limit = klevu.getObjectPath(recordQuery, "settings.limit");
                                    limit = Number(limit);
                                    if (limit > 0) {
                                        var expectedOffset = (paginationFromURL - 1) * limit;
                                        klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                                    }
                                }
                            });
                        }
                    }

                    // FILTERS
                    if (filtersFromURL && filtersFromURL.length) {
                        var facets = filtersFromURL.split(";");
                        if (facets) {
                            klevu.each(facets, function (key, facet) {
                                var splitFacet = facet.split(":");
                                if (splitFacet.length) {
                                    var facetKey = decodeURIComponent(splitFacet[0]);
                                    var facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                    var applyFilters = klevu.getObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters");

                                    if (applyFilters && applyFilters.length) { // if there're some filters
                                        var isExistingKey = false;
                                        klevu.each(applyFilters, function (key, applyFilter) {
                                            if (applyFilter.key === facetKey) {
                                                isExistingKey = true;
                                                klevu.each(facetValues, function (key, facetValue) {
                                                    var isFilterOptionMatched = false;
                                                    klevu.each(applyFilter.values, function (key, value) {
                                                        if (facetValue === value) {
                                                            isFilterOptionMatched = true;
                                                        }
                                                    });
                                                    if (!isFilterOptionMatched) {
                                                        applyFilter.values.push(facetValue);
                                                    }
                                                });
                                            }
                                        });
                                        if (!isExistingKey) {
                                            applyFilters.push({ key: facetKey, values: facetValues });
                                        }
                                    } else {
                                        klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", [{ key: facetKey, values: facetValues }]);
                                    }

                                }
                            });
                        }
                    }
                },

                updatePayloadOnPopState: function (data, scope, activeQueryId) {
                    // SET PAGINATION PAYLOAD
                    var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");
                    paginationFromURL = Number(paginationFromURL);
                    var limit = window.klevuCurrentScope.element.kObject.getScope().data.request.original.queryRequest[0].settings.limit;
                    limit = Number(limit);
                    if (limit > 0) {
                        var expectedOffset = ((paginationFromURL - 1) * limit) > 0 ? ((paginationFromURL - 1) * limit) : 0;
                        klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                        // klevu.search.modules.addParamsToURL.base.backBtnCounter.backBtn = 0;
                    }

                    // SET FILTER PAYLOAD
                    var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                    if (filtersFromURL && filtersFromURL.length) {
                        var facets = filtersFromURL.split(";");
                        // loop through all facets to get its values
                        let facetKey = '';
                        let facetValues = [];
                        let facetsArray = [];

                        klevu.each(facets, function (key, facet) {
                            var splitFacet = facet.split(":");
                            if (splitFacet.length) {
                                facetKey = decodeURIComponent(splitFacet[0]);
                                facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                facetsArray.push({ key: facetKey, values: facetValues });
                            }
                        });
                        // set the payload with correct filters:
                        klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", facetsArray);
                    } else { // reset filters if Back button pressed, and there's no filters
                        klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", []);
                    }
                }
            },
            build: true
        },
        keepFacetsWithSelectedOptionsOpened: function () {
          const selectors = {
            kuFilterBox: '.kuFilterBox',
            kuSelected: '.kuSelected',
            kuFilterNames: '.kuFilterNames',
            kuFilterNamesCollapse: '.kuFilterNames.kuFilterCollapse',
            kuFilterHead: '.kuFilterHead',
            kuFilterHeadExpand: '.kuFilterHead.kuExpand',
            kuExpand: '.kuExpand',
            kuCollapse: '.kuCollapse',
            nouiElement: '.noUi-origin',
            priceFacetBlock: '[data-filter="klevu_price"]',
            kuFilterShowAll: '.kuFilterShowAll',
            kuFilterCollapse: '.kuFilterCollapse',
          };
      
          /** Collapse Filters by default */
          (function collapseAllFilters() {
            // Replace .kuFilterHead.kuCollapse with .kuFilterHead.kuExpand
            const kuFilterHeadElements = document.querySelectorAll(selectors.kuFilterHead);
            kuFilterHeadElements.forEach(element => {
              element.classList.add(selectors.kuExpand.substring(1));
              element.classList.remove(selectors.kuCollapse.substring(1));
            });
      
            // Replace .kuFilterNames.kuCollapse with .kuFilterNames.kuExpand
            const kuFilterNamesElements = document.querySelectorAll(selectors.kuFilterNames);
            kuFilterNamesElements.forEach(element => {
              element.classList.add(selectors.kuFilterCollapse.substring(1));
              element.classList.remove(selectors.kuFilterShowAll.substring(1));
            });
          }());
      
      
          // Regular checkbox-facets
          // Check if the required elements exist
          const kuSelectedElements = document.querySelectorAll(selectors.kuFilterBox + ' ' + selectors.kuSelected);
          if (kuSelectedElements.length > 0) {
            kuSelectedElements.forEach(selectedElement => {
              // Find the parent element with the class kuFilterBox
              const filterBoxParent = findParentWithClass(selectedElement, selectors.kuFilterBox);
      
              // Look for the child with the class kuFilterHead.kuExpand
              const filterHeadChild = filterBoxParent.querySelector(selectors.kuFilterHeadExpand);
      
              // Rotate icon in the title 
              if (filterHeadChild) {
                filterHeadChild.classList.remove('kuExpand');
                filterHeadChild.classList.add('kuCollapse');
              }
      
              // Find the parent element with the class kuFilterNames.kuFilterCollapse
              const filterNamesParent = findParentWithClass(selectedElement, selectors.kuFilterNamesCollapse);
      
              // Show options
              if (filterNamesParent) {
                filterNamesParent.classList.remove('kuFilterCollapse');
                filterNamesParent.classList.add(selectors.kuFilterShowAll.substring(1));
              }
            });
          }
      
          // Price slider facet
          var isThereAnyAppliedFacets = klevu.getObjectPath(
            scope.kScope.data,
            "localOverrides.query." +
            scope.kScope.data.context.activeQueryId +
            ".filters.applyFilters.filters"
          );
          const isPriceFacetApplied = Boolean(isThereAnyAppliedFacets?.filter(val => val.key === "klevu_price").length);
          if (isPriceFacetApplied) {
            // Find the parent element with the class kuFilterNames.kuFilterCollapse
            const nouiElement = document.querySelector(`${selectors.priceFacetBlock} ${selectors.nouiElement}`);
      
            if (nouiElement) {
              const filterNamesParent = findParentWithClass(nouiElement, selectors.kuFilterNamesCollapse);
      
              // Show options
              if (filterNamesParent) {
                filterNamesParent.classList.remove('kuFilterCollapse');
                filterNamesParent.classList.add(selectors.kuFilterShowAll.substring(1));
              }
      
              // Find the parent element with the class kuFilterBox
              const filterBoxParent = findParentWithClass(nouiElement, selectors.kuFilterBox);
      
              // Look for the child with the class kuFilterHead.kuExpand
              const filterHeadChild = filterBoxParent.querySelector(selectors.kuFilterHeadExpand);
      
              // Rotate icon in the title
              if (filterHeadChild) {
                filterHeadChild.classList.remove('kuExpand');
                filterHeadChild.classList.add('kuCollapse');
              }
            }
          }
      
          // Function-helper to find the parent element with a specified class
          function findParentWithClass(element, className) {
            let parent = element.parentElement;
            while (parent) {
              if (parent.matches(className)) {
                return parent;
              }
              parent = parent.parentElement;
            }
            return null; // No matching parent found
          }
        },
        filterToggler: function (documentBody, klevuLanding) {
          klevu.event.attach(klevuLanding, "click", function ({ target }) {
            if (target.matches(".ku-filter-toggler, .ku-filter-toggler *")) {
              documentBody.classList.add("klevu-filters-opened");
            } else if (target.matches(".klevu-close-filters, .klevu-close-filters *, .kuFiltersButton_apply, .kuFiltersButton_apply *")) {
              documentBody.classList.remove("klevu-filters-opened");
            }
          });
        },
        smoothScrollToProductListingTop: function () {
          let customOffset = 60;
          const selectorsToTriggerScrollToTop = {
            pagination: '.kuPagination a',
            // filterOptions: '.klevuFilterOption',
            // Add more selectors here as needed
          }
          function _smoothScrollToKlevuTop() {
            setTimeout(function () {
                var target = document.getElementsByClassName('klevuMeta')[0];
    
                if (target) {
                    var topPosition = target.getBoundingClientRect().top + window.pageYOffset;
    
                    window.scrollTo({
                        top: topPosition - customOffset,
                        behavior: 'smooth'
                    });
                }
            }, 100);
          }
          Object.values(selectorsToTriggerScrollToTop).forEach(selector => {
            document.querySelectorAll(selector).forEach(el => el.addEventListener('click', _smoothScrollToKlevuTop));
          });
      }
    });
  })(klevu);
});

klevu.modifyRequest("catnav,landing", function (data, scope) {
  klevu.each(data.request.current.recordQueries, function (key, query) {
    klevu.setObjectPath(query, "filters.filtersToReturn.options.limit", 100);

    // No results limit
    const queryID = klevu.getObjectPath(query, "id");
    if (queryID === 'noResultsFoundPopularProductList') {
      klevu.setObjectPath(query, "settings.limit", 10);
    }
    // No results limit END
        klevu.setObjectPath(query, "filters.filtersToReturn.options.order", "INDEX");
  });

  // Restore Search Params On Page Load
  klevu.search.modules.addParamsToURL.base.restoreSearchParamsOnPageLoad(data, scope);

  // set the global scope
  window.klevuCurrentScope = scope.kScope;
  
});

klevu.afterTemplateRender("catnav,landing", function (data, scope) {
  const documentBody = document.body;
  const klevuLanding = document.getElementsByClassName("klevuLanding")[0];
  const isThisPageCategory = !klevu.getSetting(klevu, "settings.flags.setRemoteConfigLanding.build");

  klevu.search.modules.addParamsToURL.base.addURLtoHistory(data, scope);
  klevu.search.modules.keepFacetsWithSelectedOptionsOpened();
  klevu.search.modules.filterToggler(documentBody, klevuLanding);
  klevu.search.modules.smoothScrollToProductListingTop();

  if (isThisPageCategory && documentBody) {
    documentBody.classList.add('klevu-category-page');
  }

});

window.onpopstate = function (event) {
  try {
      // passing activeQueryId because it's lost once we reset the data below
      var activeQueryId = klevu.getObjectPath(window.klevuCurrentScope.element.kObject.getScope().data, "context.activeQueryId");
      // code to get ready to reset all the data
      var data = window.klevuCurrentScope.element.kObject.getScope().data;
      var scope = window.klevuCurrentScope.element;
      scope.kScope.data = scope.kObject.resetData(scope.kElem);
      scope.kScope.data.context.keyCode = 0;
      scope.kScope.data.context.eventObject = event;
      scope.kScope.data.context.event = "keyUp";
      scope.kScope.data.context.preventDefault = false;

      // Get payload for Filters & Pagination
      klevu.search.modules.addParamsToURL.base.updatePayloadOnPopState(data, scope, activeQueryId);

      // Fire request, re-render results
      klevu.event.fireChain(scope.kScope, "chains.events.keyUp", scope, scope.kScope.data, event);
  } catch (error) {
      console.log(error)
  }
};
/* ============ LANDING & CATNAV TEMPLATES ============= */

var klevuLandingTemplateProductBlockCustom = `
<% 
    var updatedProductName = dataLocal.name;
    <!-- customization -->
    if(typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') {
        updatedProductName = updatedProductName.replace(dataLocal.brand, '');
    }
    <!-- customization end -->
%>
<li ku-product-block class="klevuProduct klevuProductClick kuTrackRecentView" data-id="<%=dataLocal.id%>">
    <div class="kuProdWrap">
        <header ku-block data-block-id="ku_landing_result_item_header">
            <%=helper.render('landingProductBadge', scope, data, dataLocal) %>
        </header>
        <% var desc = [dataLocal.summaryAttribute,dataLocal.packageText,dataLocal.summaryDescription].filter(function(el) { return el; }); desc = desc.join(" "); %>
        <main ku-block data-block-id="ku_landing_result_item_info">
            <div class="kuProdTop">
                <!-- customization -->
                <div class="klevuImgWrap">
                    <a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView">
                        <img src="<%=dataLocal.image.replace('_medium', '_500x500')%>" origin="<%=dataLocal.image.replace('_medium', '_500x500')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg">
                        <%=helper.render('landingImageRollover', scope, data, dataLocal) %>
                    </a>
                    <%=helper.render('landingPageProductAddToCart',scope,data,dataLocal) %> 
                </div>
                <%=helper.render('landingProductSwatch',scope,data,dataLocal) %>
                <%=helper.render('klevuLandingProductRating',scope,data,dataLocal) %>

                <!-- customization end -->
            </div>
        </main>
        <footer ku-block="" data-block-id="ku_landing_result_item_footer">
            <div class="kuProdBottom">  
                <!-- customization -->
                <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
                    <div class="klevu-brand"><%= dataLocal.brand %></div>
                <% } %>
                <!-- customization end -->
                <div class="kuName kuClippedOne"><a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView" title="<%= updatedProductName %>"><%= updatedProductName %></a></div>
                
                <!-- customization -->
                <% if(desc && desc.length) { %>
                        <div class="kuDesc kuClippedTwo"> <%=desc%> </div>
                <% } %>
                <!-- customization end -->
                
                <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>
                    <%=helper.render('landingProductStock', scope, data, dataLocal) %>              
                <% } else { %>
                <% if(klevu.search.modules.kmcInputs.base.getShowPrices()) { %>
                    <div class="kuPrice">
                        <%
                            var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                            var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                            var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                            var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                        %>
                        <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>
                            <div class="kuSalePrice kuStartPrice kuClippedOne">
                                <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%></span>
                                <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                            </div>
                        <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                            <span class="kuOrigPrice kuClippedOne">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                            <span class="kuSalePrice kuSpecialPrice kuClippedOne">
                                <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                            </span>
                        <% } else if(!Number.isNaN(kuSalePrice)) { %>
                            <span class="kuSalePrice kuSpecialPrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                            </span>
                        <% } else if(!Number.isNaN(kuPrice)) { %>
                            <span class="kuSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                        <% } %>
                        <%=helper.render('searchResultProductVATLabel', scope, data, dataLocal) %>
                    </div>
                <% } %>
                <% } %>
            </div>
            <div class="kuProdAdditional">
                <!-- customization -->
                <!-- customization end -->
            </div>
        </footer>             
    </div>
</li>`;

var landingPageProductAddToCartCustom = `
<% if(dataLocal.inStock != "no") { %>
<% var addToCartCaption = klevu.search.modules.kmcInputs.base.getAddToCartButtonCaption(); %>
    <% if(addToCartCaption && addToCartCaption.indexOf("<img") !== -1) { %>
        <div class="kuAddtocart kuLandingAddToCartBtn" data-id="<%=dataLocal.id%>" role="button" tabindex="0" area-label="Add to cart">
            <%= addToCartCaption %>
        </div>
    <% } else { %>
        <div class="kuAddtocart kuLandingAddToCartBtn" data-id="<%=dataLocal.id%>" role="button" tabindex="0" area-label="<%= addToCartCaption %>">
            <%=helper.translate(addToCartCaption) %>    
        </div>
    <% } %>
<% } %>`;

var KlevuLandingTemplateResultsCustom = `
<div class="kuResultsListing">
    <div class="productList klevuMeta" data-section="productList">
        <div class="kuResultContent">
            <div class="kuResultWrap <%=(data.query.productList.filters.length == 0 )?'kuBlockFullwidth':''%>">
<%=helper.render('klevuLandingTemplateResultsHeadingTitle',scope,data,"productList") %>
                <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                    <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                        <div ku-block data-block-id="ku_landing_left_facets">                                
                            <%=helper.render('filters',scope,data,"productList") %>
                        </div>
                        <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_left_banner"></div>
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                        
                        <header ku-block data-block-id="ku_landing_result_header">
                        <div class="RowsContainer">
                        <div class="TopRow">
                            <%=helper.render('klevuLandingTemplateResultsHeadingTitle',scope,data,"productList") %>
                                <button class="ku-filter-toggler">
                                    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.55372 7.58824L1 7.58825M11.1818 7.58825L8.40496 7.58824M2.85124 2.41177L1 2.41173M11.1818 2.41173L4.70248 2.41177M4.70248 1V3.82352M8.40496 9V6.17648" stroke="#151515" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    
                                    <span><%= helper.translate("Filters")%></span>
                                </button>
                            <%=helper.render('filtersTop',scope,data,"productList") %>
                            <% if(helper.hasResults(data,"productList")) { %>
                                <%=helper.render('Limit',scope,data,"productList") %>
                                <%=helper.render('sortBy',scope,data,"productList") %>
                            <% } %>
                            <div class="kuClearBoth"></div>
                        </div>
                        <div class="BottomRow">
                        <%=helper.render('Limit',scope,data,"productList") %>
                        </div>
                        </div>
                        </header>

                        <div ku-block data-block-id="ku_landing_result_items">
                        <%= helper.render('kuFilterTagsTemplate',scope,data,"productList") %>

                            <div class="kuResults">
                                <% if(helper.hasResults(data,"productList")) { %>
                                        <ul>
                                            <% helper.each(data.query.productList.result,function(key,item){ %>
                                                <% if(item.typeOfRecord == "KLEVU_PRODUCT") { %>
                                                    <%=helper.render('productBlock',scope,data,item) %>
                                                <% } %>
                                            <% }); %>
                                        </ul>
                                <% } else { %>
                                    <div class="kuNoRecordsFoundLabelTextContainer">
                                        <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                    </div>
                                <% } %>
                                <div class="kuClearBoth"></div>
                            </div>
                            <%=helper.render('pagination',scope,data,"productList") %>
                        </div>
                        
                        <div ku-block data-block-id="ku_landing_other_items">
                            <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>                               
                        </div>
                        <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                        <div ku-block data-block-id="ku_landing_right_facets"></div>
                        <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_right_banner"></div>
                    </section>
                </div>
                
            </div>
        </div>
    </div>

    <% if(data.query.contentList) { %>
        <div class="contentList klevuMeta" data-section="contentList" data-result-view="list">
            <div class="kuResultContent">
                <div class="kuResultWrap <%=(data.query.contentList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                    <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                        <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                            <div ku-block data-block-id="ku_landing_left_facets">
                                
                                <%=helper.render('filters',scope,data,"contentList") %>

                            </div>
                            <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_left_banner"></div>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                            
                            <header ku-block data-block-id="ku_landing_result_header">
                                <%=helper.render('filtersTop',scope,data,"contentList") %>
                                <%= helper.render('kuFilterTagsTemplate',scope,data,"contentList") %>
                                <div class="kuClearBoth"></div> 
                            </header>

                            <div ku-block data-block-id="ku_landing_result_items">
                                <div class="kuClearBoth"></div>
                                <div class="kuResults">
                                    <% if(helper.hasResults(data,"contentList")) { %>
                                        <ul>
                                            <% helper.each(data.query.contentList.result,function(key,item){ %>
                                                <% if(item.typeOfRecord == "KLEVU_CMS") { %>
                                                    <%=helper.render('contentBlock',scope,data,item) %>
                                                <% }%>
                                            <% }); %>
                                        </ul>
                                    <% } else { %>
                                        <div class="kuNoRecordsFoundLabelTextContainer">
                                            <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                        </div>
                                    <% } %>
                                    <div class="kuClearBoth"></div>
                                </div>
                                <%=helper.render('pagination',scope,data,"contentList") %>
                            </div>
                            <div ku-block data-block-id="ku_landing_other_items">
                                <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                            </div>
                            <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                            <div ku-block data-block-id="ku_landing_right_facets"></div>
                            <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_right_banner"></div>
                        </section>
                    </div>
                    
                </div>
            </div>
        </div>
    <% } %> 

</div>`;

var klevuLandingTemplateSearchBarCustom = `
<% 
    var totalProductResultsFound = klevu.getObjectPath(data,"query.productList.meta.totalResultsFound", 0);
    var totalContentResultsFound = klevu.getObjectPath(data,"query.contentList.meta.totalResultsFound", 0);
    var resultText = 'Results';
    if((totalProductResultsFound + totalContentResultsFound) === 1){
        resultText = 'Result';
    }
 %>
<% var searchTerm = (typeof data.settings !== 'undefined' && typeof data.settings.term !== 'undefined') ? data.settings.term : '' %>
<% var queryParam = klevu.getGlobalSetting("url.queryParam"); %>
<h1 class="klevu-search-title"><%=helper.translate("Search Results")%></h1>
<div class="kuSearchResultsSearchBarContainer kuHideExtraSearch">
    <form action="/" method="get">
        <input type="text" name="<%= queryParam %>" id="search" class="kuSearchInput header-bar__search-input" placeholder="<%=helper.translate("Search our store")%>" />
    </form>
</div>

<div class="klevu-total-results">
<strong><%=totalProductResultsFound + totalContentResultsFound %></strong> <%= helper.translate(resultText) %> found for "<%=searchTerm%>"
</div>`;

var klevuLandingTemplatePaginationCustom = `
<% if(data.query[dataLocal].result.length > 0 ) { %>
    <%
        var resultsPerPage = data.query[dataLocal].meta.noOfResults;
        var totalResultsFound = data.query[dataLocal].meta.totalResultsFound - 1;
        const lastPageOffset = (Math.floor(totalResultsFound/resultsPerPage)*resultsPerPage);
        const currentOffset = data.query[dataLocal].meta.offset;
        const productListLimit = data.query.productList.meta.noOfResults;
        const currentPage = (Math.ceil(currentOffset/resultsPerPage)+1);
        const customOffsetPrev = currentOffset - productListLimit;
        const customOffsetNext = (currentOffset + (resultsPerPage)) >= lastPageOffset ? lastPageOffset : (currentOffset + (resultsPerPage));
        const customOffsetPrevTotRes = currentPage <= 1 ? 1 : (productListLimit * (currentPage - 1));
        const totalPages = (Math.ceil(totalResultsFound/resultsPerPage));
        const isLastPage = currentPage === totalPages;
        const productListTotal = data.query.productList.meta.totalResultsFound - 1;
        const lastPage = (Math.ceil(productListTotal/productListLimit) - currentPage) >= 1 ? (Math.ceil(productListTotal/productListLimit)) : 0;
        const toProducts = data.query.productList.meta.offset+productListLimit >= productListTotal ? productListTotal : data.query.productList.meta.offset+productListLimit;
    %>
    
    <div class="kuPagination kuPagination--custom">

        <div class="klevuPaginate-wrapper">

            <% if(currentOffset > 0) { %>
                <a target="_self" href="javascript:void(0)"  class="klevuPaginate klevuPaginate_prev" rel="prev" data-offset="<%= customOffsetPrev %>"><svg style="pointer-events: none;" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 4H6H1M1 4L4.28467 1M1 4L4.28467 7" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg></a>
            <% } %>

            <% if (currentPage === 2) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset - resultsPerPage)%>"><%=(Math.ceil(currentOffset/resultsPerPage))%></a>
            <% } %>
            <% if (currentPage >= 3) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset - (resultsPerPage * 2))%>"><%=(Math.ceil(currentOffset/resultsPerPage)-1)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset - resultsPerPage)%>"><%=(Math.ceil(currentOffset/resultsPerPage))%></a>
            <% } %>

            <a href="javascript:void(0);" class="kuCurrent"><%=(Math.ceil(currentOffset/resultsPerPage)+1)%></a>



            <% if(totalResultsFound >= currentOffset + resultsPerPage) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+resultsPerPage)%>"><%=(Math.ceil(currentOffset/resultsPerPage)+2)%></a>
            <% } %>
            <% if (totalPages - currentPage === 2) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+(resultsPerPage * 2))%>"><%=(Math.ceil(currentOffset/resultsPerPage)+3)%></a>
            <% } %>
            <% if (totalPages - currentPage >= 3) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+(resultsPerPage * 2))%>"><%=(Math.ceil(currentOffset/resultsPerPage)+3)%></a>
            <% } %>
            <% if (totalPages - currentPage >= 4) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+(resultsPerPage * 3))%>"><%=(Math.ceil(currentOffset/resultsPerPage)+4)%></a>
            <% } %>

            <% if(totalResultsFound >= currentOffset + resultsPerPage && totalPages > 3) { %>
                <a target="_self" href="javascript:void(0)" rel="next" class="klevuPaginate klevuPaginate_next" data-offset="<%=customOffsetNext%>"><svg width="12" style="pointer-events: none;" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 4H6H11M11 4L7.71533 1M11 4L7.71533 7" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg></a>
            <% } %>

        </div>
    </div>

<% } %>`;

var klevuLandingTemplateFiltersCustom = `
<% 
    var totalResultsFoundText = 'Result';
    if(data.query["productList"]?.meta.totalResultsFound > 1){
        totalResultsFoundText = 'Results';
    }
%>
<% if(data.query[dataLocal].filters.length > 0 ) { %>
    <div class="kuFiltersWrapper">
        <div class="kuFiltersHeader">
            <span><%= helper.translate("Filters")%></span>
            <div class='klevu-total-products'><%=data.query["productList"]?.meta.totalResultsFound%> <%=totalResultsFoundText%></div>
            <button class="klevu-close-filters">
                <svg class="icon" role="img" aria-label="Close">
                    <use xlink:href="#icon-close"><svg viewBox="0 0 612 612" id="icon-close">
                        <polygon points="612,36.004 576.521,0.603 306,270.608 35.478,0.603 0,36.004 270.522,306.011 0,575.997 35.478,611.397 306,341.411 576.521,611.397 612,575.997 341.459,306.011 "></polygon>
                    </svg></use>
                </svg>
            </button>
        </div>
        <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0">
            <% helper.each(data.query[dataLocal].filters,function(key,filter){ %>
                <% if(filter.type == "OPTIONS"){ %>
                    <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                        <a
                                            target="_self" 
                                            href="#" 
                                            title="<%=helper.escapeHTML(filterOption.name)%>" 
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>" 
                                        >
                                            <span class="kuFilterIcon"></span>
                                            <span class="kufacet-text"><%=filterOption.name%></span>
                                            <% if(filterOption.selected ==true) { %>
                                                <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                            <% } %>
                                        </a>
                                    </li>
                                    
                                <%  }); %>
                            </ul>
                            <% if(filter.options.length > 5 ) { %>
                                <div class="kuShowOpt" tabindex="-1">
                                    <span class="kuFilterDot"></span><span class="kuFilterDot"></span><span class="kuFilterDot"></span>
                                </div>
                            <% } %>
                        </div>
                    </div>
                <% } else if(filter.type == "SLIDER")  { %>
                    <div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>">
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                        </div>
                        <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">                           
                            <div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>">
                                <div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div>
                            </div>
                        </div>
                    </div>
                <% } else if (filter.type == "RATING")  { %>
                    <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <%=helper.translate(filter.label)%>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                        <a
                                            target="_self" 
                                            href="#" 
                                            title="<%=helper.escapeHTML(filterOption.name)%>" 
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                        >
                                            <span class="kuFilterIcon"></span>
                                            <span class="kufacet-text">
                                                <div class="klevuFacetStars">
                                                    <div class="klevuFacetRating" style="width:<%=(20*Number(filterOption.name))%>%;"></div>
                                                </div>
                                            </span>
                                            <% if(filterOption.selected ==true) { %>
                                                <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                            <% } %>
                                        </a>
                                    </li>
                                    
                                <%  }); %>
                            </ul>
                        </div>
                    </div>
                <% } else { %>
                    <!-- Other Facets -->
                <% } %>
            <% }); %>

        </div>
                
        <div class="kuFiltersFooter">
            <button class="kuFiltersButton kuFiltersButton_reset kuFilterTagClearAll" tabindex="0"><span title="<%= helper.translate("Clear Filters") %>" class="kuFilterTagClearAll"><%= helper.translate("Clear") %></span></button>
            <button class="kuFiltersButton kuFiltersButton_apply" tabindex="0"><span class="text"><%= helper.translate("Apply")%></span></button>
        </div>
    </div>
<% } %>`;

var klevu_newObject = klevu.dictionary("limits");
      klevu_newObject.setStorage("local");
      klevu_newObject.mergeFromGlobal();
      klevu_newObject.addElement("productList", 12);
      klevu_newObject.addElement("productListFallback", 12);
      klevu_newObject.addElement("contentList", 12);
      klevu_newObject.mergeToGlobal();

var klevuLandingTemplateLimitCustom = `
<div class="kuDropdown kuDropItemsPerpage">
          <div class="kuDropdownLabel"><%=helper.translate("Items per page : %s",helper.getLimit(dataLocal))%></div>
          <div class="kuDropdownOptions">
              <div class="kuDropOption kuLimit" data-value="12">12</div>
              <div class="kuDropOption kuLimit" data-value="24">24</div>
              <div class="kuDropOption kuLimit" data-value="36">36</div>
          </div>
      </div>
`

var klevuLandingTemplateSortByCustom = `
<% if (data.query.productList.meta.totalResultsFound) {
var totalResultsFoundText = 'result';
if(data.query.productList.meta.totalResultsFound > 1){
    totalResultsFoundText = 'results';
}
} %>
<div class="sorting-info">

    <div class="kuDropdown kuDropSortBy" role="listbox">
        <div class="kuDropdownLabel">
            <%=helper.translate(helper.myCustomSortBy(dataLocal))%>
        </div>
        <div class="kuDropdownOptions">
            <div class="kuDropOption kuSort" data-value="RELEVANCE" role="option">Relevance</div>
            <div class="kuDropOption kuSort" data-value="PRICE_ASC" role="option">Price, low to high</div>
            <div class="kuDropOption kuSort" data-value="PRICE_DESC" role="option">Price, high to low</div>
        </div>
    </div>
</div>`;

var klevuLandingTemplateBaseCustom = `
<div ku-container data-container-id="ku_landing_main_container" data-container-role="main">

    <header ku-container data-container-id="ku_landing_main_header_container" data-container-role="header">
        <section ku-block data-block-id="ku_landing_main_header_sub_panel"></section>
        <section ku-block data-block-id="ku_landing_main_header_banner">
            <%=helper.render('klevuLandingPromotionBanner',scope,data,"top") %>
            <%=helper.render('klevuLandingPromotionBanner',scope,data,"bottom") %>
        </section>
        <section ku-block data-block-id="ku_landing_main_header_site_navigation"></section>
    </header>
        
    <div class="kuContainer">
        <% if(!helper.hasResults(data,"productList") && !helper.hasFilters(data,"productList") && !helper.hasResults(data,"contentList") && !helper.hasFilters(data,"contentList")) { %>                
            <%=helper.render('noResultsFoundLanding',scope) %>
        <% } else { %>
            <%= helper.render('klevuLandingTemplateSearchBar', scope) %>   
            <%=helper.render('klevuLandingImageSearchUploadBanner',scope,data) %>             
            <%= helper.render('tab-results', scope) %>                
            <%= helper.render('results',scope) %>
        <% } %>
        <div class="kuClearBoth"></div>
    </div>

    <footer ku-container data-container-id="ku_landing_main_footer_container" data-container-role="footer">
        <section ku-block data-block-id="ku_landing_main_footer_sub_panel"></section>
        <section ku-block data-block-id="ku_landing_main_footer_banner">                

        </section>
    </footer>

</div>`;

var klevuLandingTemplateResultsHeadingTitleCustom = `
<%
    var totalProductResultsFound = klevu.getObjectPath(data,"query.productList.meta.totalResultsFound", 0);
    var totalContentResultsFound = klevu.getObjectPath(data,"query.contentList.meta.totalResultsFound", 0);
    var totalNumberOfResults = totalProductResultsFound + totalContentResultsFound;
    var resultText = totalNumberOfResults === 1 ? 'Result' : 'Results';
    var searchedTerm = helper.escapeHTML(data.settings.term);
    var isCATNAV = data.settings.isCATNAV;
    if(isCATNAV){
        searchedTerm = helper.escapeHTML(data.settings.categoryPath);
    }
%>
<div class="kuResultsHeadingTitleContainer">
<%=totalProductResultsFound + totalContentResultsFound %> <%= helper.translate(resultText) %>
</div>`;